export default __webpack_public_path__ + "media/images/dashboard_icons/website-1437ba749c029a352421ddec7e9e34d6.svg";